<template>
  <div>
    <div class="jumbotron jumbotron-fluid">
      <div class="container d-flex flex-column">
        <h1 class="display-4">
          {{ stripeAccount ? 'View your account activity with Stripe' : 'Set up your Stripe account' }}
        </h1>
        <p class="lead">
          {{ `Click the button below to ${stripeAccount ? 'go to your Stripe dashboard and see your payment activity'
                                                        : 'create your Stripe account and start getting paid automatically when people sign up for your events'}`
          }}
        </p>
        <a
          class="btn btn-lg bkg-stripe-blue mt-4 mx-auto text-light"
          :href="stripeAccount ? dashboardLink : oauthLink"
          :target="stripeAccount ? '_blank' : '_self'">
          {{ stripeAccount ? 'View Dashboard' : 'Create Account' }}
        </a>
      </div>

      <div class="container mt-5">
        <p class="font-italic text-secondary">Questions? Email <a href="mailto:founders@muvve.com">founders@muvve.com</a></p>
      </div>
    </div>

    <div class="d-flex">
      <font-awesome-icon
        :icon="['fab', 'cc-stripe']"
        :class="'stripe-blue mx-auto'"
        size="9x"
        @click="goToStripe"/>
      />
    </div>

    <Modal ref="errorModal" title="We have a problem 🙁">
      <template v-slot:body>
        There was a problem getting your Stripe account set up. Please try again, or email
        <a href="mailto:founders@muvve.com?subject=Request%20to%20register%20as%20Muvve%20event%20host%20">founders@muvve.com</a>
        with questions.
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '../components/Modal'
import axios from 'axios'
import { Store } from '../store'

const backendUrl = process.env.VUE_APP_BACKEND
const stripeState = process.env.VUE_APP_STRIPE_STATE

export default {
  components: {
    Modal: Modal
  },
  data () {
    return {
      stripeAccount: '',
      dashboardLink: '',
      oauthLink: stripeOauthLink()
    }
  },
  methods: {
    setDashboardLink () {
      if (!this.stripeAccount) return

      const vm = this
      axios.get(backendUrl + '/stripe/link')
        .then(response => {
          if (response.data.url) {
            vm.dashboardLink = response.data.url
          }
        })
    },
    goToStripe () {
      window.open('https://stripe.com/connect')
    },
    activateStripeCode (code) {
      const vm = this

      axios.post(backendUrl + '/stripe/code/activate', {
        code: code
      })
        .then(response => {
          if (response.data['stripe_account']) {
            Store.setStripeAccount(response.data['stripe_account'])
            vm.stripeAccount = Store.host.stripeAccount

            vm.$router.replace(vm.$router.path)
          } else {
            vm.showErrorModal()
          }
        })
    },
    showErrorModal () {
      this.$refs.errorModal.show()
    }
  },
  created () {
    this.stripeAccount = Store.host.stripeAccount
    this.setDashboardLink()
  },
  beforeRouteEnter (to, from, next) {
    if (to.query.code && to.query.state === stripeState) {
      next(vm => { vm.activateStripeCode(to.query.code) })
    } else {
      next()
    }
  }
}

function stripeOauthLink () {
  const oauthParams = {
    'client_id': process.env.VUE_APP_STRIPE_CLIENT,
    'response_type': 'code',
    'state': stripeState,
    'stripe_landing': 'register',
    'redirect_uri': window.location.href
  }

  const baseUrl = 'https://connect.stripe.com/express/oauth/authorize?'
  const queryString = Object.keys(oauthParams)
    .map(key => key + '=' + oauthParams[key])
    .join('&')

  return baseUrl + queryString
}

</script>

<style scoped>
.stripe-blue {
  color: #008cdd;
  transition: color .15s ease-in-out
}

.stripe-blue:hover {
  color: #0073C4
}

.bkg-stripe-blue {
  background-color: #008cdd
}

.bkg-stripe-blue:hover {
  background-color: #0073C4
}
</style>
